module.exports = __webpack_public_path__ + "img/back.e781005d.svg";